module.exports = __webpack_public_path__ + "img/consult_info2.3294e7e5.png";